import { TDateFormatToJSDate } from "@propely/propely-typings";
import Badge from "@src/components/ui-components/Badge/Badge";
import { getWorkflowsFromCache, prefetchWorkflows } from "@src/data-hooks/workflows/workflows.service";
import { IWorkflow } from "@src/data-hooks/workflows/workflows.types";
import { WorkflowTrigger } from "@src/pages/Companies/WorkflowsPage/utils/WorkflowTrigger";
import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";

export class WorkflowDataHelper extends DataObjectHelper<IWorkflow> {
  id = () => "workflows";
  allFields(): DataObjectField<any, IWorkflow>[] {
    return [
      new FirebaseDataStringField("name", t("main.name"), (data) => data.name),
      new FirebaseDataBooleanField("isActive", t("main.active"), (data) => data.isActive),
      new FirebaseDataNumberField("runCount", t("main.numberOfRuns"), (data) => data.runCount ?? 0),
      new FirebaseDataDateField("lastRun", t("main.lastRun"), (data) => TDateFormatToJSDate.safeParse(data.lastRun).data),
    ];
  }
  displayName = () => t("main.workflows");

  override getAllDatas(): IWorkflow[] {
    console.log("getAllDatas");
    return getWorkflowsFromCache() ?? [];
  }
  override loadAll(): Promise<IWorkflow[]> {
    console.log("loadAll", LocalData.currentUser.id);
    return prefetchWorkflows(LocalData.currentUser.id);
  }

  getAllDataTableDatas(documents: IWorkflow[]): DataTableData[] {
    return documents.map((workflow) => {
      return {
        key: workflow.id,
        cells: {
          name: workflow.name,
          lastRun: TDateFormatToJSDate.safeParse(workflow.lastRun).data,
          runCount: workflow.runCount ?? 0,
          status: {
            element: <Badge color={workflow.isActive ? "green" : "red"} text={workflow.isActive ? t("main.active") : t("main.notActive")} />,
            rawString: workflow.isActive ? t("main.active") : t("main.notActive"),
          },
          trigger: WorkflowTrigger.getTriggerWithId(workflow.trigger)?.name ?? t("main.notSpecified"),
        },
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "name",
        title: t("main.name"),
      },
      {
        key: "status",
        title: t("main.status"),
      },
      { key: "lastRun", title: t("main.lastRun") },
      { key: "runCount", title: t("main.numberOfRuns") },
      {
        key: "trigger",
        title: t("main.triggeredBy"),
      },
    ];
  }
  getLinkTo(key: string): string | undefined {
    return "/workflows/" + key;
  }
}
